module.exports = __webpack_public_path__ + "img/0Q3A4704_L_WoodMatted_MockedUp.e9ac3b91.jpg";